const generateCodeVerifier = (length = 43): string => {
  const mask =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~';

  let result = '';

  const randomUInts = crypto.getRandomValues(new Uint8Array(length));

  for (let i = 0; i < length; i++) {
    const randomIndex = randomUInts[i] % mask.length;
    result += mask[randomIndex];
  }

  return result;
};

const generateCodeChallenge = async (verifier: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);

  return base64UrlEncode(new Uint8Array(digest));
};

const base64UrlEncode = (array: Uint8Array) => {
  return btoa(String.fromCharCode(...array))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};

export const generatePkceChallenge = async (length?: number) => {
  const verifier = generateCodeVerifier(length);
  const challenge = await generateCodeChallenge(verifier);

  return {
    verifier,
    challenge,
  };
};

export const getPkceStorageKey = (key: string) => {
  return `pkce_verifier_${key}`;
};
